<template>
  <div class="landing_slider_container highschool">
    <div class="landing_slider">
      <div v-if="events.data">
        <div class="landing_slider_title">
          <i class="sp-ic-sm-land-highschool-icon" />
          Student <b>Events</b>
        </div>
        <event-slider v-if="events.data.count > 0" :events="events" :is-grid-view="false" page="landing" slide-to-show="4" />
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../../../../mixins/component';
import EventSlider from '../../../../../components/events/EventSlider';

export default {
  components: { EventSlider },
  mixins: [component],
  props: {
    events: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
